"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleOrderWithAssignationsAssignation = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const AssignationAutomaticEmail_1 = require("./AssignationAutomaticEmail");
let SimpleOrderWithAssignationsAssignation = class SimpleOrderWithAssignationsAssignation {
    constructor() {
        this.assignationId = (0, uuid_1.v4)();
        this.automaticEmails = [];
    }
    get status() {
        if (!(0, utils_1.isUndefinedOrNull)(this.cancelledAt)) {
            return legacy_enums_1.AssignationStatus.Cancelled;
        }
        if (!(0, utils_1.isUndefinedOrNull)(this.declinedAt)) {
            return legacy_enums_1.AssignationStatus.Declined;
        }
        if (!(0, utils_1.isUndefinedOrNull)(this.acceptedAt)) {
            return legacy_enums_1.AssignationStatus.Accepted;
        }
        return legacy_enums_1.AssignationStatus.Pending;
    }
};
exports.SimpleOrderWithAssignationsAssignation = SimpleOrderWithAssignationsAssignation;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrderWithAssignationsAssignation.prototype, "assignationId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrderWithAssignationsAssignation.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrderWithAssignationsAssignation.prototype, "userFullName", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrderWithAssignationsAssignation.prototype, "vehicleType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrderWithAssignationsAssignation.prototype, "vehicleName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", String)
], SimpleOrderWithAssignationsAssignation.prototype, "acceptationNote", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], SimpleOrderWithAssignationsAssignation.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", Date)
], SimpleOrderWithAssignationsAssignation.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", Date)
], SimpleOrderWithAssignationsAssignation.prototype, "declinedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", Date)
], SimpleOrderWithAssignationsAssignation.prototype, "cancelledAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", String)
], SimpleOrderWithAssignationsAssignation.prototype, "reason", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => AssignationAutomaticEmail_1.AssignationAutomaticEmail),
    __metadata("design:type", Array)
], SimpleOrderWithAssignationsAssignation.prototype, "automaticEmails", void 0);
exports.SimpleOrderWithAssignationsAssignation = SimpleOrderWithAssignationsAssignation = __decorate([
    (0, class_transformer_1.Exclude)()
], SimpleOrderWithAssignationsAssignation);
//# sourceMappingURL=SimpleOrderWithAssignationsAssignation.js.map